export default "__VITE_ASSET__DA231xfz__"